import { render, staticRenderFns } from "./ProviderGeneralInfo.vue?vue&type=template&id=5f8b2a1a"
import script from "./ProviderGeneralInfo.vue?vue&type=script&lang=js"
export * from "./ProviderGeneralInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f8b2a1a')) {
      api.createRecord('5f8b2a1a', component.options)
    } else {
      api.reload('5f8b2a1a', component.options)
    }
    module.hot.accept("./ProviderGeneralInfo.vue?vue&type=template&id=5f8b2a1a", function () {
      api.rerender('5f8b2a1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/management/_components/ProviderGeneralInfo.vue"
export default component.exports